/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "citizenshipCertificateTitle",
    label: "Australian citizenship certificate"
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    name: "citizenshipCertificateIntroduction",
    description: [
      "Enter all fields as printed on the Australian citizenship certificate."
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_citizenshipcertificatedvs_givenname",
    label: "First name",
    fieldRequired: true,
    validation: { required: true, max: 99 }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_citizenshipcertificatedvs_middlename",
    label: "Middle name",
    validation: { max: 99 }
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_citizenshipcertificatedvs_surname",
    label: "Last name",
    fieldRequired: true,
    validation: { required: true, max: 99 }
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_citizenshipcertificatedvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2024
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_citizenshipcertificatedvs_stock_number",
    label: "Stock number",
    fieldRequired: true,
    validation: { required: true, min: 4, max: 11 },
    hint: "Found on the top at the back of the citizenship certificate. On some older certificates it is located in the bottom left hand corner. This is not the Evidence No."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Acquisition date",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_citizenshipcertificatedvs_acquisition_date",
    label: "Acquisition date",
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2024
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_citizenshipcertificatedvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];
